import { Button, Alert, FormControlLabel, Switch } from '@tunasong/ui-lib'
import { graphHooks } from '@tunasong/graph-lib/react'
import { features, OAuth, useThunkDispatch } from '@tunasong/redux'
import type { Persisted, Profile } from '@tunasong/schemas'
import { ConfirmDialog, VBox } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'
import styles from './danger.module.css'

export interface DangerZoneProps {
  className?: string
  profile: Persisted<Profile>
}

export const DangerZone: FC<DangerZoneProps> = props => {
  const { profile } = props

  const dispatch = useThunkDispatch()

  const logout = () => {
    OAuth.logout()
    dispatch(features.user.actions.signout())
  }

  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false)
  const [deleteConfirmed, setDeleteConfirmed] = useState(false)
  const [deleteProfile] = graphHooks.useEntityDelete()
  const handleDeleteAccount = async () => {
    setShowConfirmDeleteDialog(false)
    await deleteProfile({ entity: profile })
    logout()
  }

  if (!profile) {
    return null
  }

  return (
    <VBox>
      <Alert title="Restore" severity="error" className={styles.alert}>
        <div>If you delete your account all your data will also be deleted. This action is irreversible. </div>
        <Button color="error" onClick={() => setShowConfirmDeleteDialog(true)} aria-label="delete-account">
          Delete my account and all my data
        </Button>
      </Alert>
      <ConfirmDialog
        open={showConfirmDeleteDialog}
        title="Delete account"
        onConfirm={handleDeleteAccount}
        okText="Delete my account"
        enabled={deleteConfirmed}
        text="Are you absolutely sure you want to delete your account? This action is irreversible."
        onCancel={() => setShowConfirmDeleteDialog(false)}
      >
        <Alert severity="error" className={styles.alert}>
          When you DELETE your account all your data will also be deleted. This action is irreversible.
        </Alert>
        <FormControlLabel
          control={
            <Switch
              checked={deleteConfirmed}
              aria-label="confirm-delete-account-switch"
              onChange={ev => setDeleteConfirmed(ev.target.checked)}
            />
          }
          label="I confirm I want to delete my account"
        />
      </ConfirmDialog>
    </VBox>
  )
}

export default DangerZone
